<template>
  <el-dialog :title="title"  @close="$emit('update:visible',false)">
    <div>
    111221
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="dialogVisibleTemplate = false">取 消</el-button>
      <el-button type="primary" @click="save('form')">确 定</el-button>
    </span>
  </el-dialog>
</template>
<script>

export default {
  name: "goodsSelectTESTDialog",
  props: ["visible", "templateId","templateDetailId","templateType","dialogVisibleTemplate"],
  components: {
 
  },
  watch: {
    visible() {
      console.log(this.visible,'this.visiblethis.visible')
      this.dialogVisibleTemplate = this.visible;
    }
  },
  data() {
    return {
      title:'11'
    };
  },
  created() {
    console.log('crtest')
    return
   
  },
   watch: {
            isDragging(newValue) {
              
            },
        },
  methods: {

    }
};
</script>

<style scoped>
  .outer_box{
        width: 200px;
        height: 200px;
    }
    .outer_box>div{
        white-space: nowrap;
        display: inline-block;
    }
    .outer_box>div>img{
        width: auto;
        height: auto;
        position: absolute;
    }
    .flex_wrap{
      -moz-user-select: none!important; /*火狐*/
        -webkit-user-select: none!important; /*webkit浏览器*/
        -ms-user-select: none!important; /*IE10*/
        -khtml-user-select: none!important; /*早期浏览器*/
        user-select: none!important;
    }

    canvas {
      border: 1px dashed black;
    }
</style>